/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
class EventBetHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
          uid:"",
          passcode:""
        };
    }
    onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
    }
    render() {
        return (
            <body className="bethubs">
    
    <Header history = {this.props.history} />     
    <div className="wrapper">
    <div className="w3-sidebar w3-bar-block w3-border-right" style={{"display":"none"}} id="mySidebar">
      <button onclick="w3_close()" className="w3-bar-item w3-large bg-hover">Close &times;</button>
      <ul>
        <li><a href="list-of-clients.html">List of Clients</a></li>
        <li><a href="#">Market Analysis</a></li>
        <li><a href="import-event.html">Import Event</a></li>
        <li>
            <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Live Markets </a>
            <ul className="list-unstyled collapse" id="homeSubmenu" >
                <li><a href="#">Test 1</a></li>
            </ul>
        </li>
        <li>
          <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
          <ul className="list-unstyled collapse" id="home1Submenu" >
             <li><a href="#">Test 1</a></li>
             <li><a href="#">Test 1</a></li>
          </ul>
       </li>
      </ul>
    </div>
    <div className="container-fluid container-padding-0">
            <div className="row">
               <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="main-box">
                     <h5 className="text-blue">Event Wise Bet History</h5>
                     <div className="row">
                        <div className="co-12 col-sm-3 col-md-2 col-lg-2">
                           <div className="form-group font-12">
                              <span className="d-inline-block">Select Date</span>
                              <input className="form-control d-inline-block" type="date" id="FromDate"/>
                           </div>
                        </div>
                        <div className="co-12 col-sm-3 col-md-2 col-lg-2">
                           <div className="form-group font-12">
                              <span className="d-inline-block">From Date</span>
                              <input className="form-control d-inline-block" type="date" id="FromDate" />
                           </div>
                        </div>
                        <div className="co-12 col-sm-3 col-md-3 col-lg-3">
                           <div className="form-group font-12">
                              <span className="d-inline-block">Series Name</span>
                              <select className="form-control" id="exampleFormControlSelect1">
                                 <option>All</option>
                                 <option>IPL 2020</option>
                                 <option>PayTm Series</option>
                              </select>
                           </div>
                        </div>
                        <div className="co-12 col-sm-3 col-md-3 col-lg-3">
                           <div className="form-group font-12">
                              <span className="d-inline-block">Event Name</span>
                              <select className="form-control" id="exampleFormControlSelect1">
                                 <option>India Vs Pakistan</option>
                                 <option>CSK Vs RCB</option>
                              </select>
                           </div>
                        </div>
                        <div className="co-12 col-sm-12 col-md-2 col-lg-2">
                           <div className="float-left">
                              <button className="btn btn-blue accbtn mar-top-20">Go</button>
                           </div>
                        </div>
                     </div>
                     <div className="table-responsive">
                        <table id="basic-btn" className="table  table-bordered font-12 table-sm">
                           <thead>
                              <tr className="bg-dark text-white">
                                 <th>Bet Id</th>
                                 <th>Client Id</th>
                                 <th>Date Time</th>
                                 <th>Narration</th>
                                 <th>Team Selected</th>
                                 <th>Placed</th>
                                 <th>Odds</th>
                                 <th>Stake</th>
                                 <th>P&L</th>
                                 <th>W/L</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr>
                                 <td>120616</td>  
                                 <td>cd5</td>  
                                 <td>22/05/2020 18:15:56</td>  
                                 <td>Grenadines Divers v Salt Pond Breakers &#8594; Match Odds</td>  
                                 <td>Grenadines Divers</td>  
                                 <td className="back-bg">Back</td>  
                                 <td>1.89</td>  
                                 <td>100</td>  
                                 <td className="text-success">89.00</td>
                                 <td>Salt Pond Breakers</td> 
                             </tr>
                             <tr>
                                 <td>120534</td>  
                                 <td>cd5</td> 
                                 <td>01/04/2020 14:35:19</td>  
                                 <td>Daily &#8594; Binary</td>  
                                 <td>NFY-FUT 102</td>  
                                 <td className="lay-bg">lay</td>  
                                 <td>8204</td>  
                                 <td>100</td>  
                                 <td className="text-success">100</td>  
                                 <td>8260</td> 
                             </tr>
                              <tr>
                                 <td colspan="8" className="text-right font-weight-bold">Total</td>
                                 <td className="text-red" colspan="2">189.00</td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                     <div className="row">
                        <div className="col-md-12">
                           <div className="float-right">
                              <div className="btn-group mb-2" role="group" aria-label="Basic example" id="divpagecount">
                                 <button type="button" className="btn btn-primary  btn-sm" id="FirstPage">First</button>
                                 <button type="button" className="btn btn-primary  btn-sm" id="PrevPage">Prev</button>
                                 <button type="button" className="btn btn-primary  btn-sm" id="NextPage">Next</button>
                                 <button type="button" className="btn btn-primary  btn-sm" id="LastPage">Last</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
     <Footer />
  </body>

        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(EventBetHistory);